<div
    class="section-padding-vertical-md lg:section-padding-vertical-lg w-full flex flex-col gap items-center">
    <div class="w-full flex flex-col items-center gap-6">
        <h2>Komm zu uns!</h2>
        <p class="max-w-screen-sm text-center">
            Du findest unser Büro im 12. Bezirk in Wien. Von diesem Standort helfen wir Kunden in
            Deutschland und Österreich, ihre Ziele zu übertreffen. Gerne kannst du uns auch in
            unserem Büro besuchen und persönlich kennenlernen.
        </p>
    </div>

    <div class="w-full grid grid-cols-1 lg:grid-cols-2 gap">
        <img src="images/wecodeit_office.webp" class="w-full rounded-medium aspect-[16/10]" alt="Unser Büro im 12. Bezirk in Wien" loading="lazy"/>

        <div class="my-auto grid grid-cols-2 gap">
            <div class="flex flex-col">
                <span class="text-xl text-dark">Standort</span>
                <p>
                    Am Europlatz 1,<br />
                    1120 Wien
                </p>
            </div>

            <div class="flex flex-col">
                <span class="text-xl text-dark">Öffnungszeiten</span>
                <p>nach Absprache</p>
            </div>

            <div class="flex flex-col">
                <span class="text-xl text-dark">E-Mail</span>
                <a class="no-underline text-text" href="mailto:hello@wecodeit.at"
                    >hello&#64;wecodeit.at</a
                >
            </div>

            <div class="flex flex-col">
                <span class="text-xl text-dark">Telefon</span>
                <a class="no-underline text-text" href="tel:+436603878395">+43 660 3878395</a>
            </div>
        </div>
    </div>
</div>
